<template>
    <div class="notfound">
        <img :src="img" alt="">
    </div>
</template>

<script>
  export default{
    name: 'notfound',
    data(){
      return{
        img: require('../assets/404.png')
      }
    }
  }
</script>
<style scoped>
  .notfound{
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }
  .notfound img{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/404.vue